module.exports = __webpack_public_path__ + "static/consultoria-8928a0d9ed391255df6c41dc4b87a771.svg";